export class ConfigEvr {
  NomApp: string = 'uTool';
  tokenApp: string = '08ea8446d32b86ffda06e631320ca431';

  urlEspaceAdmin: string = 'admin.utool.fr/';
  urlEspaceDistributeur: string = 'distributeur.utool.fr/';
  urlSite: string = 'utool.fr/';

  urlBase: string; // url Api
  authPage: string;
  appPage: string;

  urlApp: string = 'app.utool.fr/';
  http: string = 'http://';


  // DEMO PARAMS
  DEMO_EMAIL: string = '';
  DEMO_PASSWORD: string = '';
  // FIN DEMO PARAMS

  DOMAINE_COOKIE: string = 'utool.fr';

  constructor(http: string) {
    this.http = http;


    //setts statics Urls :
    this.urlEspaceAdmin = this.http + 'admin.utool.fr/';
    this.urlEspaceDistributeur = this.http + 'distributeur.utool.fr/';
    this.urlSite = this.http + 'utool.fr/';
  }

  // Configuration envirement dev
  configApp_dev() {
    this.urlBase = 'http://www.girafe.fr/';
    this.authPage = '/login';
    this.appPage = '/app';

    this.DEMO_EMAIL = 'opal@opal.fr';
    this.DEMO_PASSWORD = 'opal';
    this.DOMAINE_COOKIE = 'localhost';

  }

  // Configuration envirement dev alpha
  configApp_alpha() {
    this.urlBase = this.http + 'apialpha.utool.fr/';
    this.authPage = '/login';
    this.appPage = '/app';
  }


  // Configuration envirement prod beta
  configApp_beta() {
    this.urlBase = this.http + 'apibeta.utool.fr/';
    this.authPage = '/login';
    this.appPage = '/app';
  }


  // Configuration envirement prod
  configApp_prod() {
    this.urlBase = this.http + 'api.utool.fr/';
    this.authPage = '/login';
    this.appPage = '/app';
  }


  // Configuration envirement beintooAdmin
  configApp_admin(version: string) {
    switch (version) {
      case 'alpha':
        this.urlBase = this.http + 'apialpha.utool.fr/';
        break;

      case 'beta':
        this.urlBase = this.http + 'apibeta.utool.fr/';
        break;

      case 'prod':
        this.urlBase = this.http + 'api.utool.fr/';
        break;
    }

    this.authPage = '/login';
    this.appPage = '/app';
  }


  // Configuration envirement utoolDistrib
  configApp_distributeur(version: string) {

    switch (version) {
      case 'alpha':
        this.urlBase = this.http + 'apialpha.utool.fr/';
        break;

      case 'beta':
        this.urlBase = this.http + 'apibeta.utool.fr/';
        break;

      case 'prod':
        this.urlBase = this.http + 'api.utool.fr/';
        break;
    }

    this.authPage = '/login';
    this.appPage = '/app';
  }


  // Configuration envirement utoolDistrib
  configApp_site(version: string) {

    switch (version) {
      case 'alpha':
        this.urlBase = this.http + 'apialpha.utool.fr/';
        break;

      case 'beta':
        this.urlBase = this.http + 'apibeta.utool.fr/';
        break;

      case 'prod':
        this.urlBase = this.http + 'api.utool.fr/';
        break;
    }

    this.authPage = '/login';
    this.appPage = '/app';
  }

}

